import { sortTypeEnum } from '@/constants/global';
function compose(field, sort) {
    return `${field}:${sort}`;
}
const asc = (field) => compose(field, sortTypeEnum.ASC);
const desc = (field) => compose(field, sortTypeEnum.DESC);
/**
 * 정렬 추가 헬퍼
 * 정렬 기본값 asc
 * @param {QueryParameterBuilder} queryParameter
 * @param {Object.field} 정렬할 모델 키
 * @param {Object.value} 정렬할 방법. asc, desc
 * @returns {QueryParameterBuilder}
 */
const injectSortParamHelper = (queryParameter, options = []) => {
    if (!Array.isArray(options)) {
        return queryParameter;
    }
    options.forEach(({ field, value }) => {
        const targetSortType = (!value || value === sortTypeEnum.ASC) ? asc : desc;
        queryParameter.addSortBy(targetSortType(field));
    });
    return queryParameter;
};
export { asc, desc, injectSortParamHelper };
